<div>
  <div>
    <h1 class="large">Зарегистрироваться</h1>
  </div>
  @if (error) {
    <div class="common-error">
      <img src="icons/error_icon.png" alt="error">
      Произошла ошибка при регистрации: {{ error }}
    </div>
  }
  <div>
    <form #f="ngForm" (ngSubmit)="register(f)">
      <!-- email -->
      <div>
        <input type="email"
               name="email"
               placeholder="Email"
               required
               email
               ngModel
               #email="ngModel">

        @if (email.invalid && (email.touched || email.dirty)) {
          <div class="error">
            Email не валиден
          </div>
        }
      </div>

      <!-- пароль -->
      <div>
        <input type="password"
               name="password"
               placeholder="Пароль"
               required
               ngModel
               appPasswordValidationDirective
               #password="ngModel">

        @if (password.invalid && (password.touched || password.dirty)) {
          <div class="error">
            Пароль должен быть не меньше 8 символов, содержать символы в разном регистре, спецсимволы и цифры
          </div>
        }
      </div>

      <!-- подтверждение -->
      <div>
        <input type="password"
               name="confirmation"
               placeholder="Подтверждение"
               required
               ngModel
               #confirmation="ngModel">

        @if ((confirmation.touched || confirmation.dirty) && confirmation.value && confirmation.value !== password.value) {
          <div class="error">
            Пароль и подтверждение не совпадают
          </div>
        }
      </div>

      <!-- кнопка -->
      <button type="submit"
              class="primary"
              [disabled]="f.invalid || confirmation.value !== password.value">
        Зарегистрироваться
      </button>
    </form>
  </div>
  <div class="terms">
    <p>Нажимая зарегистрироваться я подтверждаю что мне есть 21 год и я согласен с
      <a>Пользовательским соглашением</a></p>
  </div>
</div>
